import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';

export type BariPostCaroQuestionnaireResponseData = {
    processQuestionnaireResponseIds: string[];
};

const bariPostCaroQuestionnaireResponseFinal: TypedSchema<BariPostCaroQuestionnaireResponseData> = {
    processQuestionnaireResponseIds: Koi.array().items(Koi.string().uuid()),
};

export const bariPostCaroQuestionnaireResponseDraftSchema = Koi.object(bariPostCaroQuestionnaireResponseFinal);
export const bariPostCaroQuestionnaireResponseFinalSchema = Koi.object(bariPostCaroQuestionnaireResponseFinal);

export type BariPostCaroQuestionnaireResponseReadKey =
    | 'eetgedrag'
    | 'sociaal_welzijn'
    | 'psychisch_welbevinden'
    | 'lichamelijke_activiteiten'
    | 'lichaamsbeeld'
    | 'seksueel_welzijn';

export type BariPostCaroQuestionnaireResponseReadLabel =
    | 'Eetgedrag'
    | 'Sociaal welzijn'
    | 'Psychisch welbevinden'
    | 'Lichamelijke activiteiten'
    | 'Lichaamsbeeld'
    | 'Seksueel welzijn';

export type BariPostCaroQuestionnaireResponseReadData = {
    eetgedrag: string[];
    lichaamsbeeld: string[];
    lichamelijke_activiteiten: string[];
    psychisch_welbevinden: string[];
    seksueel_welzijn: string[];
    sociaal_welzijn: string[];
};

export const bariPostCaroQuestionnaireResponseReadSchema: TypedReadSchema<
    BariPostCaroQuestionnaireResponseReadKey,
    BariPostCaroQuestionnaireResponseReadLabel
>[] = [
    {
        items: [
            {
                key: 'eetgedrag',
                label: 'Eetgedrag',
            },
            {
                key: 'sociaal_welzijn',
                label: 'Sociaal welzijn',
            },
            {
                key: 'psychisch_welbevinden',
                label: 'Psychisch welbevinden',
            },
            {
                key: 'lichamelijke_activiteiten',
                label: 'Lichamelijke activiteiten',
            },
            {
                key: 'lichaamsbeeld',
                label: 'Lichaamsbeeld',
            },
            {
                key: 'seksueel_welzijn',
                label: 'Seksueel welzijn',
            },
        ],
    },
];
